export const extractNames = (fullName) => {
  const nameParts = fullName.split(' ')
  let firstName, middleName, lastName
  let lastNameParts = []
  if (nameParts.length === 2) {
    ;[firstName, lastName] = nameParts
    middleName = ''
  } else {
    ;[firstName, middleName, ...lastNameParts] = nameParts
    lastName = lastNameParts.join(' ')
  }

  return { firstName, middleName, lastName }
}

export const constructAddress = (data) => {
  const { split_address } = data
  if (!split_address) return ''

  const { house, street, dist, state, pincode } = split_address

  const address = `${house ? house + ',' + ' ' : ''}${
    street ? street + ',' + ' ' : ''
  }${dist ? dist + ',' + ' ' : ''}${state ? state + ',' + ' ' : ''}${
    pincode ? pincode : ''
  }`

  return address.trim()
}

export const convertDOBToDate = (dob) => {
  var parts = dob.split('-')
  var dateObj = new Date(parts[2], parts[1] - 1, parts[0])
  var formattedDOB =
    dateObj.getFullYear() +
    '-' +
    ('0' + (dateObj.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + dateObj.getDate()).slice(-2)

  return new Date(formattedDOB)
}
